/* eslint-disable react/jsx-key */
import React from 'react';

import Loader from '@/components/Loader/Loader';
import { getDirectoryIcon } from '@/utils/getFileImage';
import { IFileListingProps } from 'interfaces/IpfsHashList/FileListing';
import folderArrow from 'public/assets/folderArrow.svg';
import foldersInactive from 'public/assets/foldersInactive.svg';

import ApiFailurePage from '../ErrorPage/ApiFailurePage';
import IpfsFilePreview from '../IpfsFilePreview/IpfsFilePreview';
import FileBox from './FileBox';

const FileListing = ({
  file,
  getFiles,
  getFIlePreviewLink,
  goBackToFile,
  nestedFolder,
  filePreviewURL,
  isLoading,
  fileErrorMessage,
}: IFileListingProps) => {
  const isPreviewFile = filePreviewURL.url === '' && filePreviewURL.type === '';
  const activeFile = nestedFolder.length
    ? nestedFolder[nestedFolder.length - 1]
    : 'Folders';
  return (
    <div className="h-full w-full">
      <div className="p-[16px] border-b-2 flex flex-row items-center h-[10%]">
        {nestedFolder && (
          <div className="flex h-full justify-center cursor-pointer text-[#8B959E] items-center ml-4">
            <div
              className={`flex h-[20px] items-center mr-2 ${
                activeFile === 'Folders' ? 'text-[#000000] ' : ''
              }  `}
              onClick={() => {
                goBackToFile(-1);
              }}
            >
              <img
                src={
                  activeFile === 'Folders'
                    ? getDirectoryIcon('root')
                    : foldersInactive.src
                }
                alt="..."
                className="mr-2 w-[18px]"
              />
              <div
                className={`${activeFile === 'Folders' ? ' font-medium ' : ''}`}
              >
                Folder
              </div>
            </div>
            {nestedFolder.map((item, index) => {
              return (
                <div
                  key={index}
                  className={`flex h-[20px] items-center mr-2 ${
                    activeFile === item ? 'text-[#000000] ' : ''
                  }  `}
                  onClick={() => {
                    goBackToFile(index);
                  }}
                >
                  <img src={folderArrow.src} alt="arrow" />
                  <img
                    src={getDirectoryIcon(item)}
                    alt="..."
                    className="mr-2 w-[18px] "
                    style={{
                      filter: `${
                        activeFile === item
                          ? 'invert(48%) sepia(17%) saturate(68%) hue-rotate(212deg) brightness(0%) contrast(109%)'
                          : ''
                      }`,
                    }}
                  />
                  <div
                    className={`${activeFile === item ? 'font-medium	' : ''}`}
                  >
                    {item}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
      <div className="overflow-y-auto h-[90%] no-scrollbar">
        {isLoading && <Loader />}
        {fileErrorMessage && <ApiFailurePage message={fileErrorMessage} />}
        {file &&
          isPreviewFile &&
          file.map((item) => {
            return (
              <FileBox
                item={item}
                key={item.path}
                getFiles={getFiles}
                getFIlePreviewLink={getFIlePreviewLink}
              />
            );
          })}
        {!isPreviewFile && (
          <IpfsFilePreview
            filePreviewURL={filePreviewURL}
            activeFile={activeFile}
          />
        )}
      </div>
    </div>
  );
};
export default FileListing;
